import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BookingContainer } from '@booking/booking.container';
import { bookingBaseRoute } from '@booking/constants/booking-routes.constants';
import {
  BOOKING_AIR_PACKAGE_CHILDREN, BOOKING_SIMPLE_CHILDREN, BOOKING_VEHICLE_CHILDREN
} from '@booking/constants/routing-children';

export const bookingRootRoute = bookingBaseRoute;

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: ':searchId/:optionId/:rateId/:travelType',
        component: BookingContainer,
        children: BOOKING_SIMPLE_CHILDREN
      },
      {
        path: ':searchId/:optionId/:rateId/:travelType/:byHoursData',
        component: BookingContainer,
        children: BOOKING_SIMPLE_CHILDREN
      },
      {
        path: ':searchId/:optionId/:rateId/:travelType/:upsellId/:upsellOptionId',
        component: BookingContainer,
        children: BOOKING_SIMPLE_CHILDREN
      },
      {
        path: ':searchId/:optionId/:rateId/:travelType/:vehicleDetailId/:companyCode/:companyName/:currencyCode',
        component: BookingContainer,
        children: BOOKING_VEHICLE_CHILDREN
      },
      {
        path: ':searchIdAir/:optionIdAir/:searchIdHotel/:optionIdHotel/:rateIdHotel/:travelType' +
          '/:currencyCode/:countryCode/:upsellId/:upsellOptionId',
        component: BookingContainer,
        children: BOOKING_AIR_PACKAGE_CHILDREN
      },
    ])
  ],
  exports: [RouterModule]
})
export class BookingRoutingModule { }
